import { useEffect } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormButton from "../../components/FormButton";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { contactMock, tokenMock } from "../../helper/mock";
import { useNavigate, useSearchParams } from "react-router";
import { $api } from "../../helper";
import { requireRules } from "../../helper/method";
import { useNotify } from "../../helper/notify";

export default function AddContactInformation() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setDashboardName } = useStore(useDashboardName);
  const notify = useNotify();
  const [searchParams] = useSearchParams();
  const postInformation = $api.useMutation(
    "post",
    "/site-api/v1/contact-information/",
  );
  const update = $api.useMutation("put", "/site-api/v1/contact-information/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/contact-information-detail/",
  );
  useEffect(() => {
    setDashboardName("افزودن اطلاعات تماس");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            contact_information_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (searchParams.get("u_id") && detail.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: { title: string; value: string },
    redirect = true,
  ) => {
    if (searchParams.get("u_id")) {
      update.mutate(
        {
          body: {
            title: Number(values.title),
            value: values.value,
            contact_information_u_id: searchParams.get("u_id") ?? "",
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/contact-information");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    } else {
      postInformation.mutate(
        {
          body: {
            title: Number(values.title),
            value: values.value,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/contact-information");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    }
  };
  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      {/* <CustomBreadcrumb
        first="مدیریت اطلاعات"
        second="اطلاعات تماس"
        third="افزودن اطلاعات تماس"
      /> */}
      <FormCard
        title="افزودن اطلاعات تماس"
        subTitle="در این بخش می‌توانید اطلاعات تماس جدید را اضافه نمایید."
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
          <FormItemInputSelect
            name={"title"}
            rules={requireRules("نوع اطلاعات تماس")}
            label="نوع اطلاعات تماس"
            className="col-span-1"
            inputProps={{
              options: contactMock,
            }}
          />
          <FormItemInput
            name={"value"}
            rules={requireRules("مقدار اطلاعات تماس")}
            label="مقدار اطلاعات تماس"
            className="col-span-1"
          />
        </div>
      </FormCard>
      <FormButton
        isPending={postInformation.isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
